module.exports = __webpack_public_path__ + "static/media/Template_29.e549a990.png";